




























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import RateCardDto from '@/models/RateCards/RateCardDto';
import UpdateRateCardRequest from '@/models/RateCards/UpdateRateCardRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'AgencyRateCardEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new RateCardDto

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentRateCard));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
        if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateRateCardRequest()
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    request.driverUnitExpenseChargeRate = this.entity.driverUnitExpenseChargeRate;
    await AgencySettingsModule.editRateCard(request)
    this.dialog = false;
  }
}
